export { clicked } from './plugins/clicked'
export { swipe } from './plugins/swipe'